import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { Box } from '@mui/material';
import { Menu, ControlledMenu, MenuItem, SubMenu } from '@szhsin/react-menu';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const ulCommon = {
  boxShadow: "0px 9.35px 18.7px 0px #00000012",
  borderRadius: '4px',
  padding: '4px',
  minWidth: '100px'
};
const commonSzhMenuItem = theme => ({
  padding: '7.5px 12px',
  paddingRight: '20px',
  borderRadius: '3.65px',
  '&::after': {
    right: '7px'
  },
  '&--hover': {
    backgroundColor: theme.customColors.purple[300],
    color: theme.customColors.purple[600],
    '& svg': {
      color: theme.customColors.purple[600]
    },
    '& i': {
      color: theme.customColors.purple[600]
    }
  },
  '&--type-checkbox': {
    '&::before': {
      content: 'none'
    }
  },
  '&--type-radio': {
    '&::before': {
      content: 'none'
    }
  },
  '&--submenu': {
    '&::after': {
      content: 'none'
    }
  }
});
const StyledMenuContainer = /*#__PURE__*/_styled(Menu, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1f4u3zg6"
})(_ref => {
  let {
    theme,
    zIndex
  } = _ref;
  return {
    zIndex,
    '& .szh-menu': _objectSpread2(_objectSpread2({}, ulCommon), {}, {
      '&::-webkit-scrollbar': {
        width: '4px'
      },
      '&::-webkit-scrollbar-track': {
        background: theme.customColors.grey[300]
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.customColors.grey[500],
        borderRadius: '5px'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: theme.customColors.grey[500]
      }
    })
  };
}, "");
const StyledControlledMenuContainer = /*#__PURE__*/_styled(ControlledMenu, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1f4u3zg5"
})(_ref2 => {
  let {
    theme,
    show = true
  } = _ref2;
  return {
    '& .szh-menu': _objectSpread2(_objectSpread2({
      height: show ? 'auto' : '0',
      overflow: 'hidden'
    }, ulCommon), !show && {
      padding: 0
    })
  };
}, "");
const StyledMenuItem = /*#__PURE__*/_styled(MenuItem, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1f4u3zg4"
})(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    color: theme.customColors.grey[700],
    fontSize: '12px',
    padding: '7.5px 12px',
    '&.szh-menu__item': commonSzhMenuItem(theme),
    '& .szh-menu__item': commonSzhMenuItem(theme),
    '& .MuiRadio-root': {
      padding: '0',
      marginRight: '5px'
    }
  };
}, "");
const StyledMenuItemInside = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1f4u3zg3"
})(_ref4 => {
  let {
    theme,
    backgroundColor = null
  } = _ref4;
  return _objectSpread2(_objectSpread2({}, backgroundColor && {
    backgroundColor
  }), {}, {
    padding: '2.5px 4px',
    borderRadius: '2.5px'
  });
}, "");
const StyledSubMenuItem = /*#__PURE__*/_styled(SubMenu, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1f4u3zg2"
})(_ref5 => {
  let {
    theme,
    sx
  } = _ref5;
  return {
    color: theme.customColors.grey[700],
    fontSize: '12px',
    padding: '0',
    '& .szh-menu__item': _objectSpread2(_objectSpread2({}, commonSzhMenuItem(theme)), sx),
    '& .MuiRadio-root': {
      padding: '0',
      marginRight: '5px'
    }
  };
}, "");
const StyledFilterNumber = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1f4u3zg1"
})(_ref6 => {
  let {
    theme
  } = _ref6;
  return {
    minHeight: '16px',
    minWidth: '16px',
    borderRadius: '50%',
    fontSize: '12px',
    marginLeft: '4px',
    background: theme.customColors.purple[500],
    color: theme.customColors.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    letterSpacing: '1px'
  };
}, "");
const StyledFilterButton = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1f4u3zg0"
})(_ref7 => {
  let {
    theme,
    size
  } = _ref7;
  return _objectSpread2(_objectSpread2({
    color: theme.customColors.grey[700],
    borderRadius: '4px',
    cursor: 'pointer',
    background: theme.customColors.white,
    display: 'inline-flex',
    alignItems: 'center'
  }, size === 'small' && {
    padding: '8px'
  }), {}, {
    height: '32px'
  });
}, "");
export { StyledControlledMenuContainer, StyledFilterButton, StyledFilterNumber, StyledMenuContainer, StyledMenuItem, StyledMenuItemInside, StyledSubMenuItem };